/* eslint-disable-next-line import/no-default-export */
export default {
  jsonapi: 'application/vnd.api+json',
} as const;
